import { Row, Col, Flex } from "antd";
import React from "react";
import ReusableTable from "../../../components/TableComponent";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import { MasterConfigs } from "../../../interfaces/entity";
import UserInfoWithId from "../../../components/ContactInfo/UserInfoWithId";
import moment from "moment";
import StatusBadge from "../../Leaves/AttendanceComponents/history/StatusBadge";
import MasterComponent from "../../../components/Forms";
import { constants } from "../../../constants/common";

const WebClockIn = () => {

    const config: MasterConfigs = {
        api: () => '/attendance-logs-admin',
        title: 'Web Clock In',
        modalTitle: () => 'Approval Leave',
        tableProps: {
            scroll: {
                y: 600
            }
        },
        searchKeys: ['punchStatus', 'dayStatus', 'clockIn'],
        getColumns: () => [
            {
                title: 'Employee Name',
                dataIndex: 'userId',
                key: 'userId',
                render: (text, record: any) => <UserInfoWithId text={record.userId} />,
                fixed: 'left',
                width: 200
            },
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                fixed: 'left',
                width: 160,
                render: (text: any, record: any) => {
                    return moment(text).format('dddd DD MMM, YYYY')
                }
            },
            {
                title: 'Shift',
                dataIndex: 'shiftId',
                key: 'shiftId',
                align: 'center',
                fixed: 'left',
                width: 100,
                render: (text: any, record: any) => {
                    return text?.name
                }
            },
            {
                title: 'Clock In',
                dataIndex: 'startDate',
                key: 'startDate',
                align: 'center',
                fixed: 'left',
                width: 150,
                onCell: (record) => {
                    let backgroundColor = '';

                    if (record.punchStatus == 'on-time') backgroundColor = '#d9f7be'; // red-ish
                    else backgroundColor = '#ffccc7'; // green-ish

                    if (!record?.startDate) {
                        backgroundColor = ''
                    }

                    return {
                        style: {
                            backgroundColor,
                        },
                    };
                },
                render: (text: any, record: any) => {
                    return text ?
                        <Flex justify="space-between">
                            {moment(text).format('hh:mm A')}
                            <span className={'first-letter:uppercase pl-2 -mt-1 font-semibold ' + (record?.punchStatus == 'on-time' ? 'text-green-700' : 'text-red-600')} >
                                {record?.punchStatus}
                            </span>
                        </Flex>
                        : '-'
                }
            },
            {
                title: 'Clock Out',
                dataIndex: 'endDate',
                key: 'endDate',
                align: 'center',
                fixed: 'left',
                width: 150,
                onCell: (record) => {
                    let backgroundColor = '';

                    if (record.punchOut == 'on-time' || record.punchOut == 'late') backgroundColor = '#d9f7be'; // red-ish
                    else backgroundColor = '#ffccc7'; // green-ish

                    if (!record?.endDate) {
                        backgroundColor = ''
                    }

                    return {
                        style: {
                            backgroundColor,
                        },
                    };
                },
                render: (text: any, record: any) => {
                    return text ?
                        <Flex justify="space-between">
                            {moment(text).format('hh:mm A')}
                            <span className={'first-letter:uppercase pl-2 -mt-1 font-semibold ' + ((record?.punchOut == 'on-time' || record?.punchOut == 'late') ? 'text-green-700' : 'text-red-600')} >
                                {record?.punchOut}
                            </span>
                        </Flex>
                        : '-'
                }
            },
            {
                title: 'Working Hours',
                dataIndex: 'totalTime',
                key: 'totalTime',
                align: 'center',
                fixed: 'left',
                width: 150,
                render: (text: any, record: any) => {
                    if (record.startDate && record.startDate) {
                        const startTime = moment(record.startDate)
                        const endTime = moment(record.endDate)
                        const duration = moment.duration(endTime.diff(startTime))
                        return duration.hours() + 'h ' + duration.minutes() + 'm'
                    } else {
                        return '-'
                    }
                }
            },
            {
                title: 'Platform',
                dataIndex: 'platform',
                key: 'platform',
                align: 'center',
                width: 100
            },
            {
                title: 'IP Address',
                dataIndex: 'ipAddress',
                key: 'ipAddress',
                align: 'center',
                width: 150
            },
            {
                title: 'Lat & Long',
                dataIndex: 'latitude',
                key: 'latitude',
                render: (text, record: any) => record.latitude ? `${record.latitude} - ${record.longitude}` : '-',
                width: 200
            },
            {
                title: 'Formatted Address',
                dataIndex: 'formatted_address',
                key: 'formatted_address',
                width: 250,
                ellipsis: true
            },
            {
                title: 'Clock Out Platform',
                dataIndex: 'clockOutPlatform',
                key: 'clockOutPlatform',
                width: 150,
                align: 'center',
                ellipsis: true
            },
            {
                title: 'Clock Out IP Address',
                dataIndex: 'clockOutIpAddress',
                key: 'clockOutIpAddress',
                width: 200
            },
            {
                title: 'Clock Out Lat & Long',
                dataIndex: 'clockOutLongitude',
                key: 'clockOutLongitude',
                render: (text, record: any) => record.clockOutLatitude ? `${record.clockOutLatitude} - ${record.clockOutLongitude}` : '-',
                width: 200
            },
            {
                title: 'Clock Out Formatted Address',
                dataIndex: 'clockOutFormatted_address',
                key: 'clockOutFormatted_address',
                width: 250,
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'dayStatus',
                key: 'dayStatus',
                align: 'center',
                fixed: 'right',
                width: 100,
                render: (text: any, record: any) => {
                    return <StatusBadge status={text} />
                }
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                width: 150,
                fixed: 'right',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Employee Name',
                name: 'userId',
                type: 'select',
                isCombo: true,
                filterFiled: true
            },
            {
                label: 'Shift type',
                name: 'shiftId',
                type: 'select',
                isCombo: true,
                filterFiled: true
            },
            {
                label: 'Date',
                name: 'date',
                type: 'date',
                filterFiled: true,
            },
        ],
        combo: [
            {
                name: 'userId',
                api: '/users',
                idKey: '_id',
                render: (text) => constants.GET_FULL_NAME(text)
            },
            {
                name: 'shiftId',
                api: '/shift-time',
                idKey: '_id',
                render: (text) => text?.name
            }
        ],
        actions: [
            {
                name: 'Filter',
                actionType: 'filter'
            }
        ]
    }

    return <MasterComponent config={config} />
};

export default WebClockIn;